var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"clock"}},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.date)+" "+_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }